<div
  class="m-px flex w-full items-center justify-between gap-6 rounded-lg bg-white px-5 py-4"
>
  <div class="flex items-center gap-4">
    <mat-icon
      class="material-icons-outlined !size-16 shrink-0 text-[64px] text-blue-dark"
      [svgIcon]="getCourseIcon()"
    ></mat-icon>
    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-2">
        <p
          class="line-clamp-2 break-words text-xl font-semibold text-blue-dark"
        >
          {{ 'portal.courses.courseTitleKeys.' + name + '.name' | transloco }}
        </p>
      </div>
      <div
        class="flex flex-wrap items-center gap-2 text-sm font-light text-grey"
      >
        <span class="break-keep">
          {{ 'portal.topicAreas.' + getTopicAreaName() | transloco }}
        </span>
        <span>•</span>
        <span>Course</span>
        <span>•</span>
        <span class="break-keep">
          {{
            'portal.courses.courseTitleKeys.' + name + '.duration' | transloco
          }}
        </span>
        <span>•</span>
        <div class="flex items-center gap-1 break-keep">
          <img
            src="assets/flags/de.svg"
            alt="Deutsch"
            title="Deutsch"
            class="flag-icon"
          />
          <span>/</span>
          <img
            src="assets/flags/gb.svg"
            alt="English"
            title="English"
            class="flag-icon"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="flex shrink-0 items-center gap-4">
    <app-link
      [description]="'portal.courses.previewDialog.activatorBtn' | transloco"
      [clickAction]="onOpenCourseDetailCard.bind(this)"
    >
      <mat-icon class="text-base font-semibold text-blue">
        open_in_new
      </mat-icon>
    </app-link>
    @if (isEditable) {
      <mat-icon
        class="material-icons-outlined hvs-icon-lg cursor-pointer"
        (click)="onButtonClick()"
      >
        close
      </mat-icon>
    }
  </div>
</div>
